import React, { useEffect, useState } from 'react'
import { string, bool, element, object, func } from 'prop-types'
import { connect } from 'react-redux'
import { Button } from '@livechat/design-system-react-components'
import delay from 'lodash/fp/delay'

import { installApp } from '@/store/installedApps'
import { handleDirectInstallationUrlFlow } from '@/utils/products'
import { useOnboarding } from '@/context/OnboardingContext'
import {
  getPublishedApp,
  hasAppAuthorization,
  getAppPayment,
  hasExternalLink,
  hasDirectInstallUrlInNewTab,
  hasInstallationProcessError,
  canInstallApplications,
} from '@/store/selectors'

export const DirectInstallUrlButton = ({
  id,
  installApp,
  canInstallApplication,
  icon,
  size,
  disabled,
  className,
  fullWidth,
  name,
  externalLink,
  hasAuth,
  openDirectInstallUrlInNewTab,
  redirect = true,
  hasInstallationError,
  kind,
}) => {
  const { checkOnboarding } = useOnboarding()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (hasInstallationError) {
      setIsLoading(false)
    }
  }, [hasInstallationError])

  const handleClick = (e) => {
    e.preventDefault()
    setIsLoading(true)

    if (canInstallApplication) {
      installApp(id, redirect)

      // Let SSO sync consent data before opening accounts pop-up
      delay(2000, () =>
        handleDirectInstallationUrlFlow({
          name,
          directInstallUrl: externalLink,
          clientId: hasAuth?.clientId,
          onClose: checkOnboarding,
          openInNewTab: openDirectInstallUrlInNewTab,
        })
      )
    }
  }

  return (
    <Button
      data-test="install-btn"
      icon={icon || ''}
      size={size}
      loading={isLoading}
      disabled={disabled}
      onClick={handleClick}
      className={className}
      kind={kind || 'primary'}
      fullWidth={fullWidth}
    >
      Get
    </Button>
  )
}

const mapStateToProps = (state, ownProps) => {
  const { id } = ownProps
  const { name } = getPublishedApp(state, id)

  return {
    name,
    hasAuth: hasAppAuthorization(state, id),
    payment: getAppPayment(state, id),
    canInstallApplication: canInstallApplications(state),
    externalLink: hasExternalLink(state, id),
    openDirectInstallUrlInNewTab: hasDirectInstallUrlInNewTab(state, id),
    hasInstallationError: hasInstallationProcessError(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    installApp: (id, redirect) => {
      dispatch(installApp.pending({ id, redirect }))
    },
  }
}

DirectInstallUrlButton.propTypes = {
  className: string,
  icon: element,
  size: string,
  disabled: bool,
  id: string,
  hasAuth: object,
  isAdmin: bool,
  openDirectInstallUrlInNewTab: bool,
  installApp: func,
  installAppForNotLoggedIn: func,
  fullWidth: bool,
  name: string,
  externalLink: string,
  redirect: bool,
  hasInstallationError: bool,
  canInstallApplication: bool,
  kind: string,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DirectInstallUrlButton)
